/**
 * "DEINE BOX" — Signature 1, the floating box.
 *
 * Shows the box once the header's copy has scrolled out of view, so there is
 * always a visible cart on screen — which is what makes the fly-to-cart arc
 * land somewhere the customer can actually see. Hidden again the moment the
 * header cart comes back, so the two are never both on screen.
 *
 * It keeps itself in sync off the same cart event bus as the header box; no
 * extra requests beyond what a cart change already makes.
 */
(function () {
  function init() {
    var float = document.querySelector('[data-cart-float]');
    var headerCart = document.querySelector('#cart-icon-bubble');
    if (!float) return;

    var countEl = float.querySelector('[data-cart-float-count]');
    var builderSheet = document.querySelector('.candy-bundle-summary-sticky');
    var headerVisible = true;

    var stickyAtc = document.querySelector('.candy-sticky-atc');

    // The product page's sticky add-to-cart bar is position:fixed at
    // bottom:0 with a higher z-index, so it sat straight over the floating
    // box (56x48px of overlap, measured) and over the last ~64px of the
    // footer. Its height is measured rather than hard-coded here: it grows
    // with the safe-area inset and would drift if the bar's contents ever
    // change. The stylesheet reads it back as --candy-atc-h.
    function syncStickyAtc() {
      var root = document.documentElement;
      var up = stickyAtc && stickyAtc.classList.contains('is-visible');
      document.body.classList.toggle('candy-has-sticky-atc', !!up);
      if (up) {
        root.style.setProperty('--candy-atc-h', Math.round(stickyAtc.getBoundingClientRect().height) + 'px');
      } else {
        root.style.removeProperty('--candy-atc-h');
      }
    }

    // While the product form's own buttons are on screen the customer is
    // already looking at the way to buy, and a bottom-right float simply
    // lands on top of the full-width CTA underneath it. The sticky bar
    // takes over the moment these scroll away, so nothing is lost.
    var buyButtons = document.querySelector('.product-form__buttons, .product-form__submit');
    var buyVisible = false;
    if (buyButtons && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          buyVisible = entry.isIntersecting;
          refresh();
        });
      }, { threshold: 0 }).observe(buyButtons);
    }

    function refresh() {
      // Never stack on top of the box builder's own bottom sheet, and never
      // compete with the header cart when that is on screen anyway.
      var sheetUp = builderSheet && builderSheet.classList.contains('is-visible') &&
        window.matchMedia('(max-width: 749px)').matches;
      var drawerOpen = document.querySelector('cart-drawer.active');
      syncStickyAtc();
      float.hidden = headerVisible || buyVisible || !!sheetUp || !!drawerOpen;
    }

    if (headerCart && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          headerVisible = entry.isIntersecting;
          refresh();
        });
      }, { threshold: 0 }).observe(headerCart);
    } else {
      headerVisible = false;
    }
    refresh();

    // The builder sheet and the drawer both change visibility without any
    // event of their own, so re-check on scroll (cheap: one class read).
    window.addEventListener('scroll', refresh, { passive: true });
    document.addEventListener('click', function () { setTimeout(refresh, 60); });

    float.addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(float);
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    });

    function syncCount(count) {
      if (!countEl) return;
      countEl.textContent = count;
      float.classList.toggle('is-empty', !count);
    }
    syncCount(parseInt(countEl && countEl.textContent, 10) || 0);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (data && typeof data.item_count !== 'undefined') {
          syncCount(data.item_count);
        } else {
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (c) { syncCount(c.item_count); })
            .catch(function () {});
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
